import { BottomSheet } from './BottomSheet';
import { Button } from '../primitives/Button';

interface ConfirmSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  /** Dismiss without confirming. Default: "Cancel". */
  dismissLabel?: string;
  confirmLabel: string;
  onConfirm: () => void;
  loading?: boolean;
  destructive?: boolean;
}

/**
 * Two-button confirmation sheet — same grid layout as invite / form actions.
 * Use instead of `window.confirm` in the resident app.
 */
export function ConfirmSheet({
  open,
  onOpenChange,
  title,
  description,
  dismissLabel = 'Cancel',
  confirmLabel,
  onConfirm,
  loading = false,
  destructive = true,
}: ConfirmSheetProps): JSX.Element {
  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title={title} description={description}>
      <div className="grid grid-cols-2 gap-3 pb-2">
        <Button
          type="button"
          variant="secondary"
          disabled={loading}
          onClick={() => onOpenChange(false)}
        >
          {dismissLabel}
        </Button>
        <Button
          type="button"
          variant={destructive ? 'danger' : 'primary'}
          loading={loading}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </div>
    </BottomSheet>
  );
}
